module.exports = __webpack_public_path__ + "media/yes6.796bd2bd.mp3";